import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';

const styles = theme => ({

});

class EventUsageDialog extends React.Component {
    render() {
        const { event_usage, active, onCloseDialog, onSubmitDialog } = this.props;

        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => onCloseDialog(false)}
            >
                <DialogTitle id="event_usage_dialog">
                    Event Usage
                </DialogTitle>
                <DialogContent>
                    {event_usage.event_list.length > 0 ?
                        <React.Fragment>
                            <p>This Event is used in a currently running course.</p>
                        </React.Fragment>
                        : null}
                    {this.props.event_usage.event_list.filter((event_info) => event_info.is_in_conflict).length > 0 ?
                        <React.Fragment>
                            <p>Students have already started/completed this event.</p>
                            <p>Saving will send a notification to students that they will need to reattempt this event.</p>
                            <p>All future attempts will use the new version.</p>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <p>No students have started this event on an unfinished course.</p>
                            <p>No notifications will be sent.</p>
                            <p>All future attempts will use the new version.</p>
                        </React.Fragment>
                    }
                    <p>If you would like to leave existing courses unaffected, consider using the Copy button.</p>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={() => onCloseDialog(false)} color="primary">
                        Cancel
                    </Button>
                    <Button variant="outlined" onClick={() => onSubmitDialog('in_use_retake')} color="primary">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default withStyles(styles, { withTheme: true })(EventUsageDialog);


// WEBPACK FOOTER //
// src/main/components/event/EventUsageDialog.js